import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class AdvertiserModel extends ApiModel {
  static get path() {
    return '/backend/advertisers/{?id}';
  }

  @computed
  get advertiserName() {
    return this.get('name', '');
  }

  @computed
  get counter() {
    return this.get('counter', 0);
  }

  @computed
  get link() {
    return this.get('link');
  }

  @computed
  get email() {
    return this.get('email');
  }

  @computed
  get logoObjectUrl() {
    return this.get('logo.objectUrl');
  }
}
